import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { featureFlags } from 'src/config/featureFlags';
import { HelpCenterTemplate } from 'src/presentations/components/templates/helpCenter/HelpCenterTemplate';
import { LandingTopWidget } from '../../organisms/landing';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';

const HelpCenterPage: React.FC = () => {
  const navigate = useNavigate();

  // Redirect to home if GUIDED_TOURS feature flag is disabled
  useEffect(() => {
    if (!featureFlags?.GUIDED_TOURS) {
      navigate('/');
    }
  }, [navigate]);

  // Don't render content if flag is disabled (redirect will happen)
  if (!featureFlags?.GUIDED_TOURS) {
    return null;
  }

  return (
    <div className='relative bg-neutral-10'>
      <LandingTopWidget />
      <LayoutSidebar>
        <HelpCenterTemplate />
      </LayoutSidebar>
    </div>
  );
};

export default HelpCenterPage;
